import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-carousel-controls',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './carousel-controls.component.html',
  styleUrls: ['./carousel-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselControlsComponent {
  @Input() canGoPrev: boolean = true;
  @Input() canGoNext: boolean = true;
  @Input() showPrev: boolean = true; // Control visibility of prev button
  @Input() showNext: boolean = true; // Control visibility of next button

  @Output() prev = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
}
